import {Mapper} from '@s-ui/domain'

export class SellVehicleConfigFormValueObjectMapper extends Mapper {
  constructor({config, configFormVOFactory, getConfigFieldsFormMapper}) {
    super()
    this._config = config
    this._configFormVOFactory = configFormVOFactory
    this._defaultInitFieldValue = this._config.get('form').defaultInitFieldValue
    this._displayTypes = this._config.get('form').displayTypes
    this._formIds = this._config.get('form').formIds
    this._formTypes = this._config.get('form').formTypes
    this._formFieldIds = this._config.get('form').formFieldIds
    this._PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL =
      this._config.get('form').PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL
    this._TRANSMISSION_TYPE_ID_MANUAL = this._config.get('search').TRANNSMISSION_TYPE_ID_MANUAL
    this._getConfigFieldsFormMapper = getConfigFieldsFormMapper
  }

  setParams({makesSpecsFormVO, userEntity, withAdditionalCarDataFields, withPostalCodeField}) {
    this._makesSpecsFormVO = makesSpecsFormVO
    this._user = userEntity ? userEntity.toJSON() : null
    this._withAdditionalCarDataFields = withAdditionalCarDataFields
    this._withPostalCodeField = withPostalCodeField

    return this
  }

  map() {
    const {
      makeId,
      modelId,
      bodyTypeDoorsId,
      fuelId,
      yearId,
      versionId,
      transmissionTypeId,
      kilometersId,
      postalCode,
      additionalTitle,
      plate,
      vehicleStatus
    } = this._formFieldIds

    const fields = [
      {field: makeId, customProps: {datalist: this._makesSpecsFormVO?.getDatalist() ?? []}},
      {field: modelId},
      {field: bodyTypeDoorsId},
      {field: fuelId},
      {field: yearId},
      {field: versionId},
      {field: transmissionTypeId},
      {
        field: kilometersId,
        customConstraints: {
          maxLength: {value: 7},
          notNull: {message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.NOTNULL'},
          pattern: {
            message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.MIN',
            pattern: this._PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL
          }
        }
      }
    ]

    const initialFieldValues = {
      [makeId]: this._defaultInitFieldValue,
      [modelId]: this._defaultInitFieldValue,
      [bodyTypeDoorsId]: this._defaultInitFieldValue,
      [fuelId]: this._defaultInitFieldValue,
      [yearId]: this._defaultInitFieldValue,
      [versionId]: this._defaultInitFieldValue,
      [transmissionTypeId]: this._TRANSMISSION_TYPE_ID_MANUAL.toString(),
      [kilometersId]: this._defaultInitFieldValue
    }

    if (this._withPostalCodeField) {
      fields.push({
        field: postalCode,
        customProps: {help: 'INSTANT_OFFER.LANDING.SHOW_YOU_CLOSEST_DEALERS'}
      })
      initialFieldValues[postalCode] = this._user?.zipCode ?? this._defaultInitFieldValue
    }

    if (this._withAdditionalCarDataFields) {
      fields.push({field: additionalTitle}, {field: plate}, {field: vehicleStatus})
      initialFieldValues[plate] = this._defaultInitFieldValue
      initialFieldValues[vehicleStatus] = this._defaultInitFieldValue
    }

    // TO DO - MOVE RULES GENERATOR TO ITS OWN MAPPER
    const formSellVehicleFieldsWithRemotePropertyOrder = [makeId, modelId, bodyTypeDoorsId, fuelId, yearId, versionId]

    const operators = {
      exists: 'EXISTS'
    }

    const getEmptyFieldRule = ({id, remote = false}) => ({
      when: [{operator: operators.exists, id}],
      then: {
        data: {
          disabled: true,
          required: true,
          datalist: [],
          value: ''
        },
        remote
      }
    })

    const getRemoteFieldRule = ({id}) => getEmptyFieldRule({id, remote: true})

    const rules = {}

    formSellVehicleFieldsWithRemotePropertyOrder.forEach((fieldId, fieldIdIndex) => {
      if (!fieldIdIndex) return
      const previousFields = formSellVehicleFieldsWithRemotePropertyOrder.slice(0, fieldIdIndex)
      const fieldRules = previousFields.map((previousFieldId, previousFieldIdIndex) => {
        return previousFieldIdIndex === previousFields.length - 1
          ? getRemoteFieldRule({id: previousFieldId})
          : getEmptyFieldRule({id: previousFieldId})
      })
      rules[fieldId] = fieldRules
    })

    const carFields = {
      display: this._displayTypes.block,
      fields: this._getConfigFieldsFormMapper.map(fields),
      id: this._formIds.sellVehicleFieldset,
      type: this._formTypes.fieldset
    }

    return this._configFormVOFactory({
      form: {
        display: this._displayTypes.block,
        fields: [carFields],
        id: this._formIds.sellVehicle,
        rules,
        type: this._formTypes.group
      },
      initialFieldValues
    })
  }
}
